<template>
  <div class="product-list">
    <!--添加产品-->
    <div class="common-level-rail">
      <el-button
        size="small"
        type="primary"
        icon="el-icon-plus"
        @click="addClick"
        v-auth="'/product/technician/add'"
        >添加产品</el-button
      >
    </div>
    <div class="common-level-rail">
      <el-button
        size="small"
        type="primary"
        icon="el-icon-plus"
        v-auth="'/product/technician/add'"
      >
        添加产品</el-button
      >
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table
          size="small"
          :data="tableData"
          border
          style="width: 100%"
          v-loading="loading"
        >
          <el-table-column prop="username" label="真实姓名" width="150px">
          </el-table-column>
          <el-table-column prop="gender" label="性别"></el-table-column>
          <el-table-column prop="birthday" label="生日"></el-table-column>
          <el-table-column prop="height" label="高度"></el-table-column>
          <el-table-column prop="introduce" label="个人介绍"></el-table-column>
          <el-table-column prop="nickName" label="昵称"></el-table-column>
          <el-table-column prop="mobile" label="电话号码"></el-table-column>
          <el-table-column
            prop="working_hours"
            label="工作时长"
          ></el-table-column>
          <el-table-column prop="lng" label="经度"></el-table-column>
          <el-table-column prop="lat" label="纬度"></el-table-column>
          <el-table-column fixed="right" label="操作" width="160">
            <template slot-scope="scope">
              <el-button
                @click="editClick(scope.row)"
                type="primary"
                size="small"
                v-auth="'/product/product/edit'"
                >编辑项目</el-button
              >
              <el-button
                @click="delClick(scope.row)"
                type="danger"
                size="small"
                v-auth="'/product/product/delete'"
                >删除项目</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!--分页-->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        background
        :current-page="curPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="totalDataNumber"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import PorductApi from "@/api/product.js";
export default {
  components: {},
  data() {
    return {
      /*切换菜单*/
      activeName: "sell",
      /*切换选中值*/
      activeIndex: "0",
      /*是否正在加载*/
      loading: true,
      /*一页多少条*/
      pageSize: 10,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索参数*/
      searchForm: {
        productName: "",
        categoryId: ""
      },
      /*列表数据*/
      tableData: [],
      /*全部分类*/
      categoryList: [],
      supplier: [],
      /*统计数据*/
      product_count: {}
    };
  },
  created() {
    /*获取列表*/
    this.getData();
  },
  methods: {
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.loading = true;
      self.curPage = val;
      self.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.pageSize = val;
      this.getData();
    },

    /*切换菜单*/
    handleClick(tab, event) {
      let self = this;
      self.curPage = 1;
      self.getData();
    },

    /*获取列表*/
    getData() {
      let self = this;
      let Params = self.searchForm;
      Params.pageIndex = self.curPage;
      Params.pageSize = self.pageSize;
      Params.type = self.activeName;
      self.loading = true;
      PorductApi.productList(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.categoryList = data.data.category;
          self.totalDataNumber = data.data.list.total;
          self.supplier = data.data.supplier;
          self.product_count = data.data.product_count;
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.getData();
    },

    /*打开添加*/
    addClick() {
      this.$router.push("/product/product/add");
    },

    /*打开编辑*/
    editClick(row) {
      this.$router.push({
        path: "/product/product/edit",
        query: {
          product_id: row.product_id,
          scene: "edit"
        }
      });
    },

    /*打开复制*/
    copyClick(row) {
      this.$router.push({
        path: "/product/product/edit",
        query: {
          product_id: row.product_id,
          scene: "copy"
        }
      });
    },
    /*删除*/
    delClick: function(row) {
      let self = this;
      let msg = "";
      if (row.productStatus == 30) {
        msg = "删除后不可恢复，确认删除该记录吗?";
      } else {
        msg = "删除后将移动到回收站，确定删除该记录吗?";
      }
      self
        .$confirm(msg, "提示", {
          type: "warning"
        })
        .then(() => {
          PorductApi.delProduct({
            product_id: row.product_id
          }).then(data => {
            self.$message({
              message: "删除成功",
              type: "success"
            });
            self.getData();
          });
        });
    },
    /*修改状态*/
    changeStatus(item, value) {
      let self = this;
      let msg = "";
      if (value == 10) {
        msg = "确认要上架该商品吗?";
      } else {
        msg = "确认要下架该商品吗?";
      }
      self
        .$confirm(msg, "提示", {
          type: "warning"
        })
        .then(() => {
          PorductApi.changeStatus({
            product_id: item.product_id,
            state: value
          }).then(data => {
            self.$message({
              message: "操作成功",
              type: "success"
            });
            self.getData();
          });
        });
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/technician/index3.vue